import _ from 'lodash';
import {
  FETCH_CHECKPOINTS,
  UPDATE_CHECKPOINT,
  DELETE_CHECKPOINT,
  CREATE_CHECKPOINT,
} from './types';
import { setErrorMessage } from './errorMessage';
import api from '../apis/api';
import getMessageFromApiError from '../util/getMessageFromApiError';

export const fetchCheckpoints = (project_uuid) => async (dispatch) => {
  if (!project_uuid) {
    throw new Error('project_uuid is required');
  }
  try {
    let res = await api.get('/checkpoint', { params: { project_uuid } });
    dispatch({
      type: FETCH_CHECKPOINTS,
      payload: res.data,
    });
  } catch (error) {
    const message = getMessageFromApiError(error);
    dispatch(setErrorMessage(message));
    throw new Error(`API Error - ${message}`);
  }
};

export const updateCheckpoint = (project_uuid, checkpoint_uuid, name) => async (dispatch) => {
  if (!project_uuid) {
    throw new Error('project_uuid is required');
  }
  try {
    const res = await api.patch(
      `/checkpoint/${checkpoint_uuid}`,
      { name: name },
      { params: { project_uuid } }
    );
    dispatch({
      type: UPDATE_CHECKPOINT,
      payload: res.data,
    });
  } catch (error) {
    const message = getMessageFromApiError(error);
    dispatch(setErrorMessage(message));
    throw new Error(`API Error - ${message}`);
  }
};

export const deleteCheckpoint = (project_uuid, checkpoint_uuid) => async (dispatch) => {
  if (!project_uuid) {
    throw new Error('project_uuid is required');
  }
  try {
    await api.delete(`/checkpoint/${checkpoint_uuid}`, {
      params: { project_uuid },
    });
    dispatch({
      type: DELETE_CHECKPOINT,
      payload: checkpoint_uuid,
    });
  } catch (error) {
    const message = getMessageFromApiError(error);
    dispatch(setErrorMessage(message));
    throw new Error(`API Error - ${message}`);
  }
};

export const createCheckpoint = (project_uuid, values) => async (dispatch) => {
  try {
    if (!values.project_uuid) {
      if (!project_uuid) {
        throw new Error('project_uuid is required');
      }
      values.project_uuid = project_uuid;
    }
    const res = await api.post('/checkpoint', values);
    if (project_uuid && res.data.project_uuid !== project_uuid) {
      return;
    }
    dispatch({
      type: CREATE_CHECKPOINT,
      payload: res.data,
    });
  } catch (error) {
    const message = getMessageFromApiError(error);
    dispatch(setErrorMessage(message));
    throw new Error(`API Error - ${message}`);
  }
};

export const exportCheckpoint =
  (project_uuid, checkpoint_uuid, values) => async (dispatch) => {
    if (!project_uuid) {
      throw new Error('project_uuid is required');
    }
    try {
      const res = await api.post(
        `/checkpoint/${checkpoint_uuid}/export`,
        values,
        {
          params: { project_uuid },
        }
      );
      dispatch({
        type: UPDATE_CHECKPOINT,
        payload: res.data,
      });
    } catch (error) {
      const message = getMessageFromApiError(error);
      dispatch(setErrorMessage(message));
      throw new Error(`API Error - ${message}`);
    }
  };

export const abortExportCheckpoint = (project_uuid, checkpoint_uuid) => async (dispatch) => {
  if (!project_uuid) {
    throw new Error('project_uuid is required');
  }
  try {
    const res = await api.delete(`/checkpoint/${checkpoint_uuid}/export`, {
      params: { project_uuid },
    });
    dispatch({
      type: UPDATE_CHECKPOINT,
      payload: res.data,
    });
  } catch (error) {
    const message = getMessageFromApiError(error);
    dispatch(setErrorMessage(message));
    throw new Error(`API Error - ${message}`);
  }
};

export const fetchCheckpoint = (project_uuid, checkpoint_uuid) => async (dispatch) => {
  try {
    const checkpoint = await getCheckpoint(project_uuid, checkpoint_uuid);
    if (!checkpoint || _.isEmpty(checkpoint)) {
      dispatch({ type: DELETE_CHECKPOINT, payload: checkpoint_uuid });
    } else {
      dispatch({
        type: UPDATE_CHECKPOINT,
        payload: checkpoint,
      });
    }
  } catch (error) {
    dispatch(setErrorMessage(error));
    throw error;
  }
};

export const getCheckpoint = async (project_uuid, checkpoint_uuid) => {
  if (!project_uuid) {
    throw new Error('project_uuid is required');
  }
  try {
    const res = await api.get(`/checkpoint/${checkpoint_uuid}`, {
      params: { project_uuid },
    });
    return res.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return;
    }
    const message = getMessageFromApiError(error);
    throw new Error(`API Error - ${message}`);
  }
};

export const getCheckpointDetails = async (project_uuid, checkpoint_uuid) => {
  if (!project_uuid) {
    throw new Error('project_uuid is required');
  }
  try {
    const res = await api.get(`/checkpoint/${checkpoint_uuid}/details`, {
      params: { project_uuid },
    });
    return res.data;
  } catch (error) {
    const message = getMessageFromApiError(error);
    throw new Error(`API Error - ${message}`);
  }
};
